import { z } from 'zod'

import { viewConfigFilterNodeForJoinOnSchema } from './filter.ts'

const referenceToSchema = z.object({
  modelName: z.string(),
  key: z.string().nullish(), // デフォルトでid
})

// joinで用いるreferenceToのプロパティ
// nodeNameが親ノード(many_to_one)のときと、子ノード(one_to_many)のときの2つのパターンがありうる
const referenceToProperty = z.object({
  nodeName: z.string(),
  modelName: z.string(),
  propertyName: z.string(),
  referenceTo: referenceToSchema,
  override: z
    .object({
      onSql: z.string().optional(),
    })
    .optional(),
})
export type ReferenceToProperty = z.infer<typeof referenceToProperty>

export const viewConfigTreeNodeSchema = z.object({
  type: z.literal(`model`), // customも許してunionにする想定
  name: z.string(), // unique
  modelName: z.string(),
  referenceToProperty: referenceToProperty.optional(), // rootの時だけoptional
  additionalJoinOn: viewConfigFilterNodeForJoinOnSchema.optional(), // referenceToで示される単純なid = id以外のjoin onを指定したいとき
  get children() {
    return viewConfigTreeNodeSchema.array().optional()
  },
  // eslint-disable-next-line sonarjs/todo-tag
  // TODO: ViewQueryNode側のスキーマをシンプルにした上で、overrideの型をPartial<ViewQueryNode>にする
  ui: z
    .object({
      // eslint-disable-next-line sonarjs/todo-tag
      // TODO: UIから引っ張ってくるか？
      label: z.string().optional(),
    })
    .optional(),
  override: z
    .object({
      // eslint-disable-next-line sonarjs/todo-tag
      // TODO: UIから引っ張ってくるか？
      searchSql: z.string().optional(),
      // XXX: 目標設定ページでのみ利用を想定
      tableSql: z.string().optional(),
      tableType: z.enum(['subquery', 'lateral_subquery']).optional(),
      joinType: z.enum(['LEFT JOIN', 'LEFT JOIN LATERAL']).optional(),
    })
    .optional(),
})

export type ViewConfigTreeNode = z.infer<typeof viewConfigTreeNodeSchema>
